import { Component } from '@angular/core';
import { environment } from 'environments/environment';
import { ReportsComponent } from '../../../shared/components/reports/reports.component';

@Component({
    templateUrl: './client-portal-client-esp-ndc-reports.component.html',
    imports: [ReportsComponent]
})
export class ClientPortalClientEspNdcReportsComponent {
  reportsUrl = `${environment.captureApi.url}/client_esp_ndc_reports`;

  constructor() {}
}
